import React from "react";
import "../style/component/OpenSourceTable.css";
function OpenSourceTable({ projects, headerTexts }) {
  return (
    <section className="open-source-table-wrapper">
      <table className="open-source-table rounded">
        <thead>
          <tr>
            {headerTexts.map((header, index) => (
              <th key={index} scope="col">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {projects.map((project) => (
            <tr key={project.id}>
              <td>{project.id}</td>
              <td>{project.name}</td>
              <td>{project.releaseDate}</td>
              <td>{project.technology}</td>
              <td>
                <a href={project.repository.url} target="_blank" rel="noopener noreferrer">
                  {project.repository.text}
                </a>
              </td>
              <td>{project.contributor}</td>
              <td>{project.notes}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}

export default OpenSourceTable;
